import React from "react";

const ApplicationContext = React.createContext(null);

export default ApplicationContext;